<template>

</template>

<script>
    export default {
        name: "gorev"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/ozel/gorev.vue